import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'app/reducers';

import { CompaniesUIActions } from '../company/actions';

@Injectable()
export class ChartsResolver implements Resolve<boolean> {
    constructor(private store: Store<AppState>) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

        const companyId = route.params['companyId'];
        this.store.dispatch(CompaniesUIActions.setCurrentCompany({ companyId }));
        return true;

    }
}
